import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { DescontoInterface } from 'app/module/desconto-interface';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class DescontoService {
	private url: string = environment.g2e_api;

	private httpOptions = {
		headers: new HttpHeaders({
			'Content-Type': 'application/json; charset=UTF-8',
			'Authorization': 'Bearer ' + localStorage.getItem("tokenApiG2E")
		}),
	}

	constructor(private http: HttpClient) { }

	public get(): Observable<DescontoInterface[]> {
		return this.http.get<DescontoInterface[]>(`${this.url}desconto`, this.httpOptions).pipe(
			(res) => res,
			(error) => error
		);
	}
}
